
import keyMirror from 'fbjs/lib/keyMirror';

export const ConfirmClearArraysModalActionTypes = keyMirror({
  OPEN_CONFIRM_CLEAR_ARRAYS_MODAL: undefined,
  HIDE_CONFIRM_CLEAR_ARRAYS_MODAL: undefined,
});
